<template>
  <div>
    <div class="header-tra-cuu">
      <span class="ml-3">Kế hoạch điều động tàu ngày {{searchTopTauAll}}</span>
    </div>
    <div style="display: flex;">
      <span style="margin: 8px 8px 0px 10px;">
        Ngày: 
      </span>
      <v-menu
        ref="menuTopTau"
        :close-on-content-click="false"
        v-model="menuTopTauAll"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        :style="{}"
        style="margin-top: 8px;"
        max-width="290px"
        min-width="290px"
        >
        <v-text-field
        slot="activator"
        v-model="searchTopTauAll"
        persistent-hint
        class="pb-0 my-0"
        ></v-text-field>
        <v-date-picker v-model="dateSearchTopTauAll" no-title @input="menuTopTauAll = false"></v-date-picker>
      </v-menu>
      <v-icon size="17" style="margin-left: 10px; cursor: pointer;" @click="menuTopTauAll = !menuTopTauAll">date_range</v-icon>
      <v-switch v-model="switch1" @change="changeTypePart" hide-details class="ml-4 mt-2"
      ></v-switch>
    </div>

    <content-placeholders v-if="loadingDataItem">
      <content-placeholders-img />
      <content-placeholders-heading />
    </content-placeholders>
    
    <div v-for="(value, name) in dataItems">
      <div class="caption-header mt-3">
        {{value[0]['portRegionName']}}
      </div>
      
      <div class="mt-3" style="overflow: auto;">
        <v-data-table
          :headers="headersKhDieuDong"
          :items="value"
          class="table-bordered danhSachHoSoTable__class"
          hide-actions
          :no-data-text="'Không tìm thấy hồ sơ '"
          :no-results-text="'Không tìm thấy hồ sơ '"
        >
          <template slot="headers" slot-scope="props">
            <tr style="background: #316BB6; color: #ffff;">
              <th style="color: #ffff !important; font-weight: normal !important;" v-for="header in props.headers" v-html="header.text">
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td class="text-xs-center" v-for="(itemKey, index) in headersKhDieuDong" :style="headersKhDieuDong[index]['style']">
              <div v-if="itemKey.id === 'chanelCodeList'">
                <div v-for="(item, index) in props.item[itemKey.display]" :key="'chanelCodeList' + index">{{item}}</div>
              </div>

              <div v-else-if="itemKey.id === 'timeOfArrival'">
                <div v-if="props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1'">
                  {{props.item['timeHHMMOfArrival']}}
                </div>
                <div v-else>
                  {{props.item['timeHHMMOfDeparture']}}
                </div>
              </div>
              
              <!-- <div v-else-if="itemKey.id === 'tugboatList'">
                <span v-if="props.item['tugboatList'] && props.item['tugboatList'] !== 'null'" v-html="props.item['tugboatList']">
                </span>
              </div>

              <div v-else-if="itemKey.id === 'pilotList'">
                <div v-if="props.item['pilotList'] && props.item['pilotList'] !== 'null'" v-html="props.item['pilotList']">
                </div>
              </div> -->

              <span v-else-if="itemKey.id === 'tugboatList'">
                <!-- <div style="font-size: 10px;">{{props.item['shortTugboatList'] ?  props.item['shortTugboatList'] : props.item['tugboatList']}}</div> -->
                <div style="font-size: 10px;" v-if="props.item['shortTugboatList'] && props.item['shortTugboatList'] !== 'null'" v-html="props.item['shortTugboatList']">
                </div>
                <div style="font-size: 10px;" v-else v-html="props.item['tugboatList']">
                </div>
              </span>

              <span v-else-if="itemKey.id === 'pilotList'">
                <!-- <div style="font-size: 10px;">{{props.item['shortPilotList'] ? props.item['shortPilotList'] : props.item['pilotList']}}</div> -->
                <div style="font-size: 10px;" v-if="props.item['shortPilotList'] && props.item['shortPilotList'] !== 'null'" v-html="props.item['shortPilotList']">
                </div>
                <div style="font-size: 10px;" v-else v-html="props.item['pilotList']">
                </div>
              </span>


              <div v-else-if="(props.item['noticeShipType'] === 2 || props.item['noticeShipType'] === '2') && itemKey.id === 'portHarbourCode'">
                <div style="font-size: 10px;">{{props.item['portHarbourShortName']}}, {{props.item['portWharfShortName']}}</div>
              </div>
              <div v-else-if="(props.item['noticeShipType'] === 2 || props.item['noticeShipType'] === '2') && itemKey.id === 'portWharfCode'">
                <div style="font-size: 10px;">{{props.item['initFrom'] || 'P/S'}}</div>
              </div>

              <div v-else-if="(props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') && itemKey.id === 'portHarbourCode'">
                <div style="font-size: 10px;">{{props.item['initFrom'] || 'P/S'}}</div>
              </div>
              <div v-else-if="(props.item['noticeShipType'] === 1 || props.item['noticeShipType'] === '1') && itemKey.id === 'portWharfCode'">
                <div style="font-size: 10px;">{{props.item['portHarbourShortName']}}, {{props.item['portWharfShortName']}}</div>
              </div>

              <div v-else-if="itemKey.id === 'portHarbourCode'">
                <div style="font-size: 10px;"><!-- {{props.item['initFrom'] || 'P/S'}} -->{{checkInitfrom(props.item)}}</div>
              </div>
              <div v-else-if="itemKey.id === 'portWharfCode'">
                <div style="font-size: 10px;">{{props.item['portHarbourShortName']}}, {{props.item['portWharfShortName']}}</div>
              </div>
                
              <span v-else-if="itemKey.id === 'maxDraft'">
                <div style="font-size: 10px;">{{props.item['maxDraft'] ? props.item['maxDraft'].replace('/', ' / ') : ''}}</div>
              </span>

              <span v-else-if="itemKey.id === 'shipAgencyCode'">
                <div style="font-size: 10px;">{{props.item['shipAgencyShortName'] ?  props.item['shipAgencyShortName'] : props.item['shipAgencyName']}}</div>
              </span>

              <div style="font-size: 10px;" v-else>{{props.item[itemKey.display]}}</div>
            </td>
          </template>
        </v-data-table>
      </div>
    </div>
    
    <div v-for="item in arrNotData" class="caption-header mt-3">
      {{item}}
    </div>

  </div>
</template>
<script>
import supportData from '@/store/support.json'
import toastr from 'toastr'
import VueScrollingTable from 'vue-scrolling-table'
const groupBy = key => array =>
array.reduce((objectsByKeyValue, obj) => {
  const value = obj[key]
  objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
  return objectsByKeyValue
}, {})
toastr.options = {
  'closeButton': true,
  'timeOut': '3000'
}
export default {
  props: {
    type: '',
    documentTypeCode: '',
    documentStatusCode: '',
    stateDisplay: ''
  },
  components: {
    'vue-scrolling-table': VueScrollingTable
  },
  provide: {
  },
  data: () => ({
    dialogPTTND: false,
    arrNotData: [],
    supportData: supportData,
    searchTopTauAll: '',
    dataItems: {
    },
    menuTopTauAll: false,
    dateSearchTopTauAll: '',
    headersKhDieuDong: supportData.headersTauKhDieuDong,
    loadingDataItem: false,
    portRegionItems: [],
    adv: {
    },
    loadingDialog: false,
    typeNavigate: '',
    itemsDialog: [],
    headersDialog: [],
    headersDialogPTTND: [
      {
        'text': 'STT',
        'align': 'left',
        'sortable': false,
        'id': 'stt',
        'type': 'text',
        'style': {
          'min-width': '5em',
          'max-width': '5em'
        }
      },
      {
        'text': 'Tên phương tiện',
        'align': 'center',
        'sortable': false,
        'value': 'tentau',
        'id': 'shipName',
        'display': 'shipName',
        'type': 'text',
        'style': {
          'min-width': '19em',
          'max-width': '19em'
        }
      },
      {
        'text': 'Số đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'title',
        'id': 'registryNumber',
        'display': 'registryNumber',
        'type': 'text',
        'style': {
          'min-width': '14em',
          'max-width': '14em'
        }
      },
      {
        'text': 'Ngày hết hạn <br> đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'ngayhethandk',
        'id': 'expiredDate',
        'display': 'expiredDate',
        'type': 'text',
        'style': {
          'min-width': '16em',
          'max-width': '16em'
        }
      },
      {
        'text': 'Xem lịch sử vào rời',
        'align': 'center',
        'sortable': false,
        'value': 'xemlichsu',
        'id': 'xemLichSu',
        'display': 'xemLichSu',
        'type': 'text',
        'style': {
          'min-width': '15.1em',
          'max-width': '15.1em'
        }
      }
    ],
    headersDialogTau: [
      {
        'text': 'STT',
        'align': 'left',
        'sortable': false,
        'id': 'stt',
        'type': 'text',
        'style': {
          'min-width': '5em',
          'max-width': '5em'
        }
      },
      {
        'text': 'Tên tàu',
        'align': 'center',
        'sortable': false,
        'value': 'tentau',
        'id': 'shipName',
        'display': 'shipName',
        'type': 'text',
        'style': {
          'min-width': '15em',
          'max-width': '15em'
        }
      },
      {
        'text': 'Số đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'title',
        'id': 'registryNumber',
        'display': 'registryNumber',
        'type': 'text',
        'style': {
          'min-width': '11em',
          'max-width': '11em'
        }
      },
      {
        'text': 'Hô hiệu',
        'align': 'center',
        'sortable': false,
        'value': 'hohieu',
        'id': 'callSign',
        'display': 'callSign',
        'type': 'text',
        'style': {
          'min-width': '11em',
          'max-width': '11em'
        }
      },
      {
        'text': 'Ngày hết hạn <br> đăng ký',
        'align': 'center',
        'sortable': false,
        'value': 'ngayhethandk',
        'id': 'expiredDate',
        'display': 'expiredDate',
        'type': 'text',
        'style': {
          'min-width': '12em',
          'max-width': '12em'
        }
      },
      {
        'text': 'Xem lịch sử vào rời',
        'align': 'center',
        'sortable': false,
        'value': 'xemlichsu',
        'id': 'xemLichSu',
        'display': 'xemLichSu',
        'type': 'text',
        'style': {
          'min-width': '15.1em',
          'max-width': '15.1em'
        }
      }
    ],
    totalDsTau: 0,
    initData: null,
    titleDS: '',
    maritimeCode: 0
  }),
  watch: {
    '$route': function (newRoute, oldRoute) {
      let vm = this
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.$store.commit('setSwitch1', true)
      } else {
        vm.$store.commit('setSwitch1', false)
      }
    },
    dateSearchTopTauAll (val) {
      this.searchTopTauAll = this.parseDate(val)
      this.loadDataTau()
    }
  },
  computed: {
    switch1 () {
      return this.$store.getters.switch1
    },
    // maritimeCode () {
    //   return this.$store.getters.maritimeCode
    // },
    checkShowBtn () {
      let vm = this
      if (vm.initData) {
        if (vm.initData.hasOwnProperty('user') && vm.initData.user && vm.initData.user['userId']) {
          return true
        }
      }
      return false
    }
  },
  created () {
    let vm = this
    // this.loadDataTau()
    vm.$store.dispatch('loadInitResource').then(function (result) {
      vm.initData = result
      if (vm.code === 'KeHoachDieuDongTau2') {
        vm.$store.commit('setSwitch1', true)
      } else {
        vm.$store.commit('setSwitch1', false)
      }
      vm.loadMaritimeCode().then(result => {
        vm.getCurentDate()
      })
    })
  },
  methods: {
    checkInitfrom (item) {
      if (item && item['shortInitFrom']) {
        return item['shortInitFrom']
      } else if (item && item['initFrom']) {
        return item['initFrom']
      }
      return 'P/S'
    },
    loadMaritimeCode: function (query) {
      var vm = this
      let param = {
      }
      param['isDelete'] = 0
      param['start'] = -1
      param['end'] = -1
      return new Promise((resolve, reject) => {
        vm.$store.dispatch('getDmGtReportCategories', param).then(function (result) {
          if (result && result['length']) {
            vm.maritimeCode = result[0] ? result[0]['category'] : 0
            resolve(result[0])
          } else {
            resolve({})
          }
        }).catch(function (xhr) {
          console.log(xhr)
          reject(false)
        })
      })
    },
    loadDsTau: function (data) {
      var vm = this
      vm.loadingDialog = true
      vm.$store.dispatch('loadInitResource').then(function (result) {
        let query = {}
        query['url'] = result['getVmaShip_Boat_URL']
        query['getShip'] = true
        query['start'] = 0
        query['end'] = 15
        for (var key in data) {
          query[key] = data[key]
        }
        for (var keyAdv in vm.adv) {
          query[keyAdv] = vm.adv[keyAdv]
        }
        vm.$store.dispatch('loadDanhSachTauBien', query).then(result => {
          if (result && result['data']) {
            vm.itemsDialog = result['data']
          } else {
            vm.itemsDialog = []
          }
          vm.totalDsTau = result['total'] || 0
          vm.loadingDialog = false
        }).catch(xhr => {
          vm.itemsDialog = []
          vm.loadingDialog = false
        })
      })
    },
    inKeHoachDieuDong () {
      let vm = this
      vm.$store.dispatch('inKeHoachDieuDongTheoNgay', {
        start: -1,
        end: -1,
        maritimeCode: vm.maritimeCode,
        markedAsArrival: '3,4,5,7,8,9',
        markedAsDeparture: '3,4,5,7,8,9',
        noticeShipType: '1,2,4',
        timeOfArrival: vm.searchTopTauAll
      }).then(result => {
        if (result) {
          window.open(result, '_blank')
        } else {
          toastr.error('Không tìm thấy file!')
        }
      }).catch(xhr => {
        toastr.error('Không tìm thấy file!')
      })
    },
    loadPortRegion: function (query, data) {
      var vm = this
      let param = {
        categoryId: 'DM_PORT_REGION'
      }
      if (vm.id && vm.id !== '0') {
        delete param['isDelete']
      } else {
        param['isDelete'] = 0
      }
      if (query) {
        for (var key in query) {
          param[key] = query[key]
        }
      }
      param['maritimeCode'] = vm.maritimeCode
      param['start'] = -1
      param['end'] = -1
      vm.$store.dispatch('loadDataDm', param).then(function (result) {
        vm.portRegionItems = result
        let arrNotData = []
        if (data) {
          vm.portRegionItems.forEach((item, index) => {
            if (!data.hasOwnProperty(item['portRegionCode'])) {
              console.log('not Property', item['portRegionCode'])
              arrNotData.push(item['portRegionNameVN'])
            }
          })
        }
        vm.arrNotData = arrNotData
      }).catch(function (xhr) {
        console.log(xhr)
      })
    },
    changeTypePart () {
      let vm = this
      if (vm.switch1) {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau2'
        })
      } else {
        vm.$router.push({
          path: '/tra-cuu/ke_hoach/0/0/KeHoachDieuDongTau'
        })
      }
    },
    getCurentDate () {
      let date = new Date()
      this.dateSearchTopTauAll = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    },
    parseDate (date) {
      if (!date) return null
      console.log(date)
      const [year, month, day] = date.split('-')
      return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
    },
    loadDataTau () {
      let vm = this
      // console.log('Source=====dataItem==============>>>>>>>>', result)
      // let data = supportData['data'] || []
      // let groupByPortRegionName = groupBy('portRegionCode')
      // vm.dataItems = groupByPortRegionName(data)
      // console.log('data+++dataItems===================>>>>>>>>', vm.dataItems)
      // vm.loadPortRegion(null, vm.dataItems)
      vm.loadingDataItem = true
      vm.$store.dispatch('loadInitResource').then(function (resultInit) {
        return new Promise((resolve, reject) => {
          let url = resultInit['findVmaItinerary_VmaItinerarySchedule_VmaScheduleShifting_URL']
          vm.$store.dispatch('loadDanhSachTauBien', {
            url: url,
            start: -1,
            end: -1,
            maritimeCode: vm.maritimeCode,
            markedAsArrival: '3,4,5,7,8,9',
            markedAsDeparture: '3,4,5,7,8,9',
            noticeShipType: '1,2,4',
            timeOfArrival: vm.searchTopTauAll
          }).then(result => {
            if (result && !result.hasOwnProperty('errorCode')) {
              console.log('Source=====dataItem==============>>>>>>>>', result)
              let data = result['data'] || supportData['data']
              let groupByPortRegionName = groupBy('portRegionCode')
              vm.dataItems = groupByPortRegionName(data)
              console.log('data+++dataItems===================>>>>>>>>', vm.dataItems)
              vm.loadingDataItem = false
              vm.loadPortRegion(null, vm.dataItems)
              resolve(vm.dataItems)
            } else {
              vm.loadingDataItem = false
              resolve([])
            }
          }).catch(xhr => {
            vm.loadingDataItem = false
            resolve([])
          })
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// KeHoachDieuDongTau_2.vue?2f415400